"use client"

import { RouteOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `RouteOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const RouteOffIcon = component(Icon)({ as: RouteOff })
